// Sub routes
export const WORK_PLAN = "work-plan";
export const PEOPLE = "people";
export const DEV_PANEL = "devpanel";
